import { Component, OnInit } from '@angular/core';
import { ToolsService } from 'src/app/services/tools/tools.service';
import * as moment from 'moment';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-invalid-slot',
  templateUrl: './alert-invalid-slot.component.html',
  styleUrls: ['./alert-invalid-slot.component.css']
})
export class AlertInvalidSlotComponent implements OnInit {

  orderHour: any =this.tools.getStor("hour_order")? moment(this.tools.getStor("hour_order")).format("HH:mm"):null;
  innerHeight: number = window.innerHeight;

  constructor(
    private dialogRef: MatDialogRef<AlertInvalidSlotComponent>,
    private tools: ToolsService
  ) { }

  ngOnInit() {
   
  }

  closeDial() {
    this.dialogRef.close();
  }

}
